import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FormFooter from '../../../common/forms/FormFooter';
import DriverSelect from '../../../common/forms/select/DriverSelect';
import FormItem from '../../../common/forms/FormItem';
import DatePicker from '../../../common/forms/input/DatePicker';
import CabinCrewSelect from '../../../common/forms/select/CabinCrewSelect';

const selector = formValueSelector('DriverTripHistoryForm');

const DriverTripHistoryForm = ({ handleSubmit, driver, cabinCrew }) => {
  
  const isDriverSelected = !!(driver && driver.value);
  const isCabinCrewSelected = !!(cabinCrew && cabinCrew.value);

  return (<Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Conductor" required>
        <Field
          name="driver"
          component={DriverSelect}
          label="Conductor"
          placeholder="Conductor"
          isClearable
          isDisabled={isCabinCrewSelected}
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
        <FormItem label="Tripulante" required>
          <Field
            name="cabinCrew"
            component={CabinCrewSelect}
            label="Tripulante"
            placeholder="Tripulante"
            isClearable
            isDisabled={isDriverSelected}
          />
        </FormItem>
      </FormGroup>
    <FormGroup row>
      <FormItem label="Fecha Inicio">
        <Field name="startDate" component={DatePicker} />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Fecha Final">
        <Field name="endDate" component={DatePicker} />
      </FormItem>
    </FormGroup>
    <FormFooter saveButtonText="Buscar" saveButtonIcon="fa fa-search" />
  </Form>)
};

DriverTripHistoryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  driver: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  cabinCrew: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
};

DriverTripHistoryForm.defaultProps = {
  driver: null,
  cabinCrew: null,
};

const mapStateToProps = (state) => ({
  driver: selector(state, 'driver'),
  cabinCrew: selector(state, 'cabinCrew'),
});

const formComponent = reduxForm({
  form: 'DriverTripHistoryForm',
})(DriverTripHistoryForm);

export default connect(mapStateToProps, null)(formComponent);
